// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Admin panel design tokens — scoped to \`.oa-route\`.
 *
 * Same discipline as the Weave (pages/multi-agent/styles/multi-agent-tokens.css) and Testing
 * (pages/testing/styles/testing-tokens.css) token layers, and deliberately NOT a copy of either:
 * the admin panel is a records surface (tables, forms, roster cards), not a conversation or a live
 * stage, so it needs table/row/toolbar primitives those two do not have. Every value derives from
 * the SAME global shell variables (--background / --card / --border / --primary / --success / …),
 * so the three modules stay one visual system without duplicating colour values.
 *
 * Rules kept intentionally tight:
 *   - 5 type sizes (micro / meta / body / title / hero) — nothing else in the module
 *   - 1 accent (global --primary) + 3 state colours (ok / warn / err), used ONLY for state
 *   - 2 surface tiers (page, raised) — no card inside a card inside a card
 *   - 1 ease, 2 durations
 *   - responsive is driven by CONTAINER queries, not viewport breakpoints: the panel lives inside a
 *     collapsible sidebar shell, so the space it actually has is not the width of the window
 */

.oa-route {
	/* ── Type ─────────────────────────────────────────────────────────────── */
	--oa-fs-micro: 11px;
	--oa-fs-meta: 12px;
	--oa-fs-body: 13px;
	--oa-fs-title: 15px;
	--oa-fs-hero: 19px;

	--oa-leading-tight: 1.35;
	--oa-leading-body: 1.55;
	--oa-tracking-micro: 0.06em;

	/* ── Colour ───────────────────────────────────────────────────────────── */
	--oa-bg: hsl(var(--background));
	--oa-surface: hsl(var(--card));
	--oa-surface-soft: hsl(var(--muted) / 0.4);
	--oa-border: hsl(var(--border));
	/* One hairline weight for every divider in the module. The old panel mixed
	   \`border-border\`, \`border-border/60\` and \`border-border/40\` on adjacent
	   elements, which reads as sloppy alignment rather than as hierarchy. */
	--oa-divider: color-mix(in oklab, hsl(var(--border)) 58%, transparent);
	--oa-text: hsl(var(--foreground));
	--oa-text-muted: hsl(var(--muted-foreground));
	--oa-accent: hsl(var(--primary));
	--oa-accent-soft: hsl(var(--primary) / 0.1);

	/* State colours use the text-safe \`-strong\` variants (see globals.css): the base
	   --success/--warning are tuned as FILLS and measure ~2:1 as text on their own tint. */
	--oa-state-ok: hsl(var(--success-strong));
	--oa-state-warn: hsl(var(--warning-strong));
	--oa-state-err: hsl(var(--destructive-strong));

	/* Panel chrome — same recipe as Weave/Testing so the modules read as siblings. */
	--oa-app-bg: color-mix(in oklab, hsl(var(--background)) 93%, hsl(var(--foreground)) 7%);
	--oa-panel-bg: color-mix(in oklab, hsl(var(--card)) 94%, hsl(var(--background)) 6%);
	--oa-panel-bg-soft: color-mix(in oklab, hsl(var(--card)) 86%, hsl(var(--background)) 14%);

	/* ── Geometry ─────────────────────────────────────────────────────────── */
	--oa-radius-sm: 6px;
	--oa-radius-md: 10px;
	--oa-radius-lg: 14px;

	/* One rhythm. Every gap/padding in the module is one of these. */
	--oa-space-1: 4px;
	--oa-space-2: 8px;
	--oa-space-3: 12px;
	--oa-space-4: 16px;
	--oa-space-5: 24px;

	/* Horizontal gutter shared by the header, the toolbar, every table cell and every
	   row — so the page has exactly one left edge and one right edge at any width. */
	--oa-gutter: 16px;

	/* ── Depth ────────────────────────────────────────────────────────────── */
	--oa-shadow-soft: hsl(var(--foreground) / 0.06);
	--oa-shadow-hard: hsl(var(--foreground) / 0.12);
	--oa-shadow-sm: 0 1px 2px var(--oa-shadow-soft), 0 0 0 1px hsl(var(--border) / 0.7);
	--oa-shadow-md:
		0 4px 6px -1px var(--oa-shadow-soft), 0 2px 4px -2px var(--oa-shadow-soft),
		0 0 0 1px hsl(var(--border) / 0.8);

	/* ── Motion ───────────────────────────────────────────────────────────── */
	--oa-motion: 140ms;
	--oa-motion-lg: 220ms;
	--oa-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);

	/* ── Layout ───────────────────────────────────────────────────────────── */
	--oa-header-h: 52px;
	--oa-toolbar-h: 44px;
	--oa-row-h: 44px;

	font-size: var(--oa-fs-body);
	line-height: var(--oa-leading-body);
	color: var(--oa-text);

	/*
	 * The panel is measured against ITSELF, not the viewport. \`@container\` queries below key off
	 * this, which is the only correct answer when the same component renders beside an expanded
	 * sidebar, beside a collapsed one, and inside a dialog.
	 *
	 * \`width: 100%\` is load-bearing, not decoration: \`container-type: inline-size\` implies
	 * \`contain: inline-size\`, which stops the contents from contributing to the element's own
	 * width. Inside any parent that sizes children by content — a flex row, an inline-block, a
	 * grid track set to \`auto\` — that collapses the whole module to its minimum width. Stating the
	 * width explicitly makes the module immune to what its host happens to be.
	 */
	container-type: inline-size;
	container-name: oa;
	width: 100%;
	min-width: 0;

	/*
	 * Contain the module's height, so the panel produces ONE scrollbar instead of two.
	 *
	 * Every panel here is \`h-full min-h-0 flex-col\` with a \`flex-1 overflow-y-auto\` body, which is
	 * meant to keep all scrolling inside that body. It did not: the body's content height also reached
	 * \`.studio-content\` (a fixed-height block with visible overflow) and from there \`.studio-main\`,
	 * whose \`overflow-y: auto\` then produced a SECOND scrollbar beside the panel's own. Measured on the
	 * Overview tab: \`.studio-main\` 2462/900 and scrollable, with the inner body already at 3003/655.
	 *
	 * \`clip\` rather than \`hidden\`, matching \`.studio-shell\`'s existing \`overflow-y: clip\`: it contains
	 * the overflow without creating a scroll container, so nothing can be programmatically scrolled
	 * here by accident. Verified that the inner body still scrolls on every tab and that sticky table
	 * headers still resolve against it, since their scrollport is inside this element.
	 */
	overflow: clip;
}

@container oa (min-width: 720px) {
	.oa-route {
		--oa-gutter: 20px;
	}
}

/* ── Surfaces ───────────────────────────────────────────────────────────── */

/*
 * The whole panel is ONE surface. The previous version nested a \`studio-card\` inside a
 * \`studio-card\` inside a \`Card\` (three borders and three backgrounds between the page and a
 * number), which is what made it read as a template rather than a product. Sections are separated
 * by hairlines and whitespace; a border is spent only where something is genuinely a raised object
 * (a role card the user can act on).
 */
.oa-route .oa-panel {
	background: linear-gradient(
		180deg,
		color-mix(in oklab, var(--oa-panel-bg) 98%, hsl(var(--foreground)) 2%),
		var(--oa-panel-bg)
	);
	border: 1px solid var(--oa-divider);
	border-radius: var(--oa-radius-md);
	overflow: hidden;
}

/* A raised object inside the panel — a role card, a stat tile. Exactly one border level deep. */
.oa-route .oa-raised {
	background: var(--oa-surface);
	border: 1px solid var(--oa-divider);
	border-radius: var(--oa-radius-md);
}

.oa-route .oa-raised-interactive {
	transition:
		border-color var(--oa-motion) var(--oa-ease),
		box-shadow var(--oa-motion) var(--oa-ease),
		background-color var(--oa-motion) var(--oa-ease);
}

.oa-route .oa-raised-interactive:hover {
	border-color: color-mix(in oklab, var(--oa-accent) 34%, var(--oa-border));
	box-shadow: var(--oa-shadow-sm);
}

.oa-route .oa-header {
	min-height: var(--oa-header-h);
	padding-inline: var(--oa-gutter);
}

/*
 * The header switches between two deliberate layouts rather than being allowed to wrap.
 *
 * Wrapping looked fine until it happened: the spend figure is right-aligned so its digits line up
 * with the page's right edge, and once the header wrapped, "right" was the right edge of the
 * figure's own little box in the middle of a new line, which reads as an alignment mistake. Below
 * the threshold the stat is simply a second line under the title, left-aligned like everything else.
 */
.oa-route .oa-header {
	flex-direction: column;
	align-items: flex-start;
}

.oa-route .oa-header-stat {
	text-align: left;
}

@container oa (min-width: 760px) {
	.oa-route .oa-header {
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
	}

	.oa-route .oa-header-stat {
		text-align: right;
	}
}

/* Toolbar strip above a table: search, filters, the section's primary action. */
.oa-route .oa-toolbar {
	min-height: var(--oa-toolbar-h);
	padding-inline: var(--oa-gutter);
	border-bottom: 1px solid var(--oa-divider);
	background: color-mix(in oklab, var(--oa-panel-bg) 86%, transparent);
}

/* Footer strip under a table: result counts, pagination. Mirrors the toolbar so a table is
   visually bracketed by two matching rails instead of ending in mid-air. */
.oa-route .oa-footer-rail {
	padding-inline: var(--oa-gutter);
	border-top: 1px solid var(--oa-divider);
	background: color-mix(in oklab, var(--oa-panel-bg) 86%, transparent);
}

/* ── Type utilities ───────────────────────────────────────────────────────
 *
 * Deliberately UNSCOPED, unlike everything else in this file.
 *
 * Radix renders dialogs in a portal on \`<body>\`, outside \`.oa-route\` — so scoped as
 * \`.oa-route .oa-meta\` these silently did nothing inside every dialog in the module, and a label
 * meant to be 11px uppercase muted rendered as plain body text. The bug is invisible in review
 * because the markup looks right.
 *
 * \`.oa-route\` still supplies the CUSTOM PROPERTIES these read, and every var has a fallback for the
 * portal case. The \`oa-\` prefix is unique to this module, so unscoping cannot collide. The
 * \`[data-tone]\` variants stay one specificity step above the base, which is what they need.
 */

.oa-micro {
	font-size: var(--oa-fs-micro, 11px);
	font-weight: 600;
	letter-spacing: var(--oa-tracking-micro, 0.06em);
	line-height: var(--oa-leading-tight, 1.35);
	text-transform: uppercase;
	color: var(--oa-text-muted, hsl(var(--muted-foreground)));
}

/*
 * \`.oa-meta\` is (0,2,0) and therefore beats a Tailwind colour utility like \`text-foreground\`
 * (0,1,0) — so \`className="oa-meta text-foreground"\` silently rendered muted. Rather than leave
 * that trap for the next person, the two colours meta text is allowed to take are part of the
 * class, selected with \`data-tone\`. Anything not expressible here should not be \`.oa-meta\`.
 */
.oa-meta {
	font-size: var(--oa-fs-meta, 12px);
	line-height: var(--oa-leading-tight, 1.35);
	color: var(--oa-text-muted, hsl(var(--muted-foreground)));
}

.oa-meta[data-tone="strong"] {
	color: var(--oa-text, hsl(var(--foreground)));
}

.oa-meta[data-tone="err"] {
	color: var(--oa-state-err, hsl(var(--destructive-strong)));
	font-weight: 500;
}

.oa-body {
	font-size: var(--oa-fs-body);
	line-height: var(--oa-leading-body);
}

.oa-title {
	font-size: var(--oa-fs-title, 15px);
	font-weight: 600;
	letter-spacing: -0.011em;
	line-height: 1.3;
	color: var(--oa-text, hsl(var(--foreground)));
}

.oa-hero {
	font-size: var(--oa-fs-hero);
	font-weight: 600;
	letter-spacing: -0.014em;
	line-height: 1.25;
	color: var(--oa-text);
}

/* ── Tabs ───────────────────────────────────────────────────────────────── */

/*
 * Underline tabs on a Radix Tabs root, so the roving-tabindex/arrow-key behaviour and the
 * tab/tabpanel wiring come from the primitive rather than from hand-rolled buttons. The underline
 * is a pseudo-element on the ACTIVE trigger — the previous implementation animated a fixed-width
 * (\`w-16\`) bar to a computed percentage, so it only lined up with a tab by coincidence.
 */
.oa-route .oa-tablist {
	display: flex;
	gap: var(--oa-space-1);
	padding-inline: var(--oa-gutter);
	border-bottom: 1px solid var(--oa-divider);
	overflow-x: auto;
	scrollbar-width: none;
}
.oa-route .oa-tablist::-webkit-scrollbar {
	display: none;
}

.oa-route .oa-tab {
	position: relative;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	flex: none;
	padding: 9px 10px;
	border: 0;
	background: transparent;
	color: var(--oa-text-muted);
	font-size: var(--oa-fs-body);
	font-weight: 500;
	white-space: nowrap;
	cursor: pointer;
	transition: color var(--oa-motion) var(--oa-ease);
}

.oa-route .oa-tab:hover {
	color: var(--oa-text);
}

.oa-route .oa-tab[data-state="active"] {
	color: var(--oa-text);
	font-weight: 600;
}

.oa-route .oa-tab::after {
	content: "";
	position: absolute;
	inset-inline: 6px;
	bottom: -1px;
	height: 2px;
	border-radius: 2px 2px 0 0;
	background: var(--oa-accent);
	opacity: 0;
	transform: scaleX(0.6);
	transition:
		opacity var(--oa-motion) var(--oa-ease),
		transform var(--oa-motion) var(--oa-ease);
}

.oa-route .oa-tab[data-state="active"]::after {
	opacity: 1;
	transform: scaleX(1);
}

.oa-route .oa-tab:focus-visible {
	outline: 2px solid var(--oa-accent);
	outline-offset: -2px;
	border-radius: var(--oa-radius-sm);
}

/* Count pill on a tab — the number lives on the thing it counts, instead of in a separate
   always-on stat strip that repeated the same four numbers on every tab. */
.oa-route .oa-tab-count {
	min-width: 18px;
	padding: 0 5px;
	border-radius: 999px;
	background: var(--oa-surface-soft);
	color: var(--oa-text-muted);
	font-size: var(--oa-fs-micro);
	font-weight: 600;
	font-variant-numeric: tabular-nums;
	line-height: 16px;
	text-align: center;
}

.oa-route .oa-tab[data-state="active"] .oa-tab-count {
	background: var(--oa-accent-soft);
	color: var(--oa-accent);
}

/* An unresolved count that needs attention (pending invitations) reads as state, not decoration. */
.oa-route .oa-tab-count[data-tone="warn"] {
	background: color-mix(in oklab, var(--oa-state-warn) 14%, transparent);
	color: var(--oa-state-warn);
}

/*
 * ── Sub-tabs ────────────────────────────────────────────────────────────────
 *
 * The second navigation row, inside People. Deliberately QUIETER than \`.oa-tab\`: two tab bars of
 * equal weight stacked on top of each other read as one confusing eight-item bar, and the reader
 * cannot tell which level they are choosing at. So this row is smaller, sits on the soft surface
 * rather than on the page ground, and marks its selection with a filled pill instead of a second
 * accent underline competing with the one directly above it.
 *
 * It reuses \`.oa-tab-count\`, so a count means the same thing on both levels.
 */
.oa-route .oa-subtablist {
	display: flex;
	gap: var(--oa-space-1);
	padding: 6px var(--oa-gutter);
	border-bottom: 1px solid var(--oa-divider);
	background: var(--oa-surface-soft);
	overflow-x: auto;
	scrollbar-width: none;
}
.oa-route .oa-subtablist::-webkit-scrollbar {
	display: none;
}

.oa-route .oa-subtab {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	flex: none;
	padding: 5px 10px;
	border: 0;
	border-radius: var(--oa-radius-sm);
	background: transparent;
	color: var(--oa-text-muted);
	font-size: var(--oa-fs-meta);
	font-weight: 500;
	white-space: nowrap;
	cursor: pointer;
	transition:
		color var(--oa-motion) var(--oa-ease),
		background-color var(--oa-motion) var(--oa-ease);
}

.oa-route .oa-subtab:hover {
	color: var(--oa-text);
	background: color-mix(in oklab, var(--oa-text) 6%, transparent);
}

.oa-route .oa-subtab[data-state="active"] {
	color: var(--oa-text);
	font-weight: 600;
	background: var(--oa-surface);
	box-shadow: inset 0 0 0 1px var(--oa-divider);
}

.oa-route .oa-subtab:focus-visible {
	outline: 2px solid var(--oa-accent);
	outline-offset: -2px;
}

/* ── Table ──────────────────────────────────────────────────────────────── */

/*
 * The module's single table idiom. Members, invitations, per-member usage and per-service usage all
 * use it, so a column header, a row height and a numeric cell mean the same thing everywhere.
 * The @ncoder/ui Table primitive's defaults (h-12 header, p-4 cells) are tuned for marketing-density
 * tables; an admin roster needs to show 12 rows without scrolling, not 4. Overridden here rather
 * than in the primitive so no other module's tables move.
 */
.oa-route .oa-table {
	width: 100%;
	border-collapse: separate;
	border-spacing: 0;
	font-size: var(--oa-fs-body);
	/*
	 * \`fixed\`, so a column's width is the width it was given rather than the width of its widest
	 * unbreakable value. Under the default \`auto\` algorithm a single long address —
	 * "priya.raghunathan@a-very-long-customer-domain-name.example.com" — widened its column past the
	 * panel, pushed every other column off the right edge and made \`truncate\` a no-op, because a
	 * column that has already grown to fit its content has nothing to truncate.
	 *
	 * Every table in the module gives an explicit width to all of its columns except the one that
	 * should absorb the remainder, which is exactly the contract \`fixed\` needs.
	 */
	table-layout: fixed;
}

.oa-route .oa-table thead th {
	position: sticky;
	top: 0;
	z-index: 1;
	height: 34px;
	padding: 0 var(--oa-space-3);
	border-bottom: 1px solid var(--oa-divider);
	/* Opaque: the body scrolls UNDER the header, so a translucent header would smear rows. */
	background: var(--oa-panel-bg);
	color: var(--oa-text-muted);
	font-size: var(--oa-fs-micro);
	font-weight: 600;
	letter-spacing: var(--oa-tracking-micro);
	text-transform: uppercase;
	text-align: left;
	white-space: nowrap;
}

.oa-route .oa-table thead th:first-child {
	padding-inline-start: var(--oa-gutter);
}
.oa-route .oa-table thead th:last-child {
	padding-inline-end: var(--oa-gutter);
}

.oa-route .oa-table tbody td {
	height: var(--oa-row-h);
	padding: 6px var(--oa-space-3);
	border-bottom: 1px solid color-mix(in oklab, var(--oa-divider) 60%, transparent);
	vertical-align: middle;
}

.oa-route .oa-table tbody td:first-child {
	padding-inline-start: var(--oa-gutter);
}
.oa-route .oa-table tbody td:last-child {
	padding-inline-end: var(--oa-gutter);
}

.oa-route .oa-table tbody tr:last-child td {
	border-bottom: 0;
}

.oa-route .oa-table tbody tr {
	transition: background-color var(--oa-motion) var(--oa-ease);
}

.oa-route .oa-table tbody tr:hover {
	background: var(--oa-surface-soft);
}

/* Row-level actions stay hidden until the row is hovered or something inside it has focus, so a
   long roster reads as data rather than as a wall of icon buttons — but they are never hidden from
   the keyboard or from a touch device, where \`:hover\` never fires. */
.oa-route .oa-row-actions {
	opacity: 0;
	transition: opacity var(--oa-motion) var(--oa-ease);
}
.oa-route tr:hover .oa-row-actions,
.oa-route tr:focus-within .oa-row-actions {
	opacity: 1;
}
@media (hover: none) {
	.oa-route .oa-row-actions {
		opacity: 1;
	}
}

/* A nested detail table (the per-service breakdown inside an expanded member row) must not carry
   the same weight as its parent, or the nesting is invisible. */
.oa-route .oa-subtable-shell {
	background: var(--oa-surface-soft);
	border-inline-start: 2px solid color-mix(in oklab, var(--oa-accent) 45%, transparent);
}

.oa-route .oa-subtable thead th {
	position: static;
	height: 28px;
	background: transparent;
	border-bottom: 1px solid color-mix(in oklab, var(--oa-divider) 60%, transparent);
}

.oa-route .oa-subtable tbody td {
	height: 32px;
	border-bottom: 0;
}

.oa-route .oa-subtable tbody tr:hover {
	background: transparent;
}

.oa-route .oa-num {
	text-align: right;
	font-variant-numeric: tabular-nums;
}

/*
 * A numeric column's HEADER, right-aligned over the figures it names.
 *
 * This rule exists because \`text-align: left\` on \`.oa-route .oa-table thead th\` (0,2,2) silently beat
 * the Tailwind \`.text-right\` utility (0,1,0) that \`PlainHeader align="right"\` emitted — so every
 * numeric header in the module sat left-aligned above right-aligned values, and had done since the
 * table chrome was written. Measured, not guessed: \`getComputedStyle(th).textAlign\` returned \`left\`
 * on every such header across all four tabs.
 *
 * Expressed as \`th.oa-num\` rather than by weakening the base rule, so headers and cells now share one
 * word for "this column is numeric" — the same vocabulary the cells already used.
 */
.oa-route .oa-table thead th.oa-num {
	text-align: right;
}

/* Sortable column header. The whole cell is the hit target, and the arrow only appears for the
   column actually in effect so the header row stays quiet. */
.oa-route .oa-th-sort {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	width: 100%;
	/* Fills the header cell rather than wrapping only the text: a 17px-tall click target is under
	   the WCAG 2.2 minimum, and a header whose hit area is smaller than the header is a small,
	   constant irritation when sorting a table. */
	height: 100%;
	min-height: 24px;
	border: 0;
	background: transparent;
	padding: 0;
	color: inherit;
	font: inherit;
	letter-spacing: inherit;
	text-transform: inherit;
	cursor: pointer;
	transition: color var(--oa-motion) var(--oa-ease);
}

.oa-route .oa-th-sort:hover {
	color: var(--oa-text);
}

.oa-route .oa-th-sort:focus-visible {
	outline: 2px solid var(--oa-accent);
	outline-offset: 2px;
	border-radius: 3px;
}

.oa-route th[aria-sort]:not([aria-sort="none"]) .oa-th-sort {
	color: var(--oa-text);
}

/* ── Card-view fallback for a narrow container ──────────────────────────── */

/*
 * A 6-column roster cannot be squeezed into a 380px panel — squeezing it is exactly how admin
 * tables end up with 3-character-wide columns. Below the container breakpoint the same rows render
 * as stacked cards (see \`useOaNarrow\`), and this is the shell for those.
 */
.oa-route .oa-card-row {
	display: flex;
	flex-direction: column;
	gap: var(--oa-space-2);
	padding: var(--oa-space-3) var(--oa-gutter);
	border-bottom: 1px solid color-mix(in oklab, var(--oa-divider) 60%, transparent);
}

.oa-route .oa-card-row:last-child {
	border-bottom: 0;
}

/* ── Segmented control ──────────────────────────────────────────────────── */

.oa-route .oa-segmented {
	position: relative;
	display: inline-flex;
	align-items: center;
	gap: 2px;
	padding: 2px;
	border: 1px solid var(--oa-divider);
	border-radius: 999px;
	background: var(--oa-surface-soft);
}

/* ── Interactive ────────────────────────────────────────────────────────── */

.oa-route .oa-interactive {
	transition:
		background-color var(--oa-motion) var(--oa-ease),
		border-color var(--oa-motion) var(--oa-ease),
		color var(--oa-motion) var(--oa-ease);
}

.oa-route :where(button, a, input, select, textarea, [tabindex]):focus-visible {
	outline: 2px solid var(--oa-accent);
	outline-offset: 2px;
}

/* ── Skeleton ───────────────────────────────────────────────────────────── */

@keyframes oa-pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.45;
	}
}

.oa-route .oa-skeleton {
	border-radius: var(--oa-radius-sm);
	background: color-mix(in oklab, hsl(var(--muted-foreground)) 12%, transparent);
	animation: oa-pulse 1.6s var(--oa-ease) infinite;
}

/* ── Entrance ───────────────────────────────────────────────────────────── */

@keyframes oa-fade-in {
	0% {
		opacity: 0;
		transform: translateY(3px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

/*
 * ONE entrance animation on the tab panel as a whole. The previous version ran a \`useTrail\` spring
 * per row plus a cross-fade between two absolutely-stacked panels — 200 members meant 200 springs
 * driving 200 committed frames, and the stagger delayed the data an admin came to read.
 */
.oa-route .oa-fade-in {
	animation: oa-fade-in var(--oa-motion-lg) var(--oa-ease) both;
}

/* ── Reduced motion ─────────────────────────────────────────────────────── */

@media (prefers-reduced-motion: reduce) {
	.oa-route .oa-fade-in {
		animation: none;
	}
	.oa-route .oa-skeleton {
		animation: none;
	}
	.oa-route .oa-tab::after,
	.oa-route .oa-interactive,
	.oa-route .oa-raised-interactive,
	.oa-route .oa-row-actions {
		transition-duration: 1ms;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/org-admin/styles/org-admin-tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;CACC,4EAA4E;CAC5E,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;;CAElB,wBAAwB;CACxB,uBAAuB;CACvB,2BAA2B;;CAE3B,4EAA4E;CAC5E,+BAA+B;CAC/B,8BAA8B;CAC9B,0CAA0C;CAC1C,+BAA+B;CAC/B;;yEAEwE;CACxE,sEAAsE;CACtE,iCAAiC;CACjC,6CAA6C;CAC7C,gCAAgC;CAChC,2CAA2C;;CAE3C;wFACuF;CACvF,yCAAyC;CACzC,2CAA2C;CAC3C,8CAA8C;;CAE9C,iFAAiF;CACjF,uFAAuF;CACvF,mFAAmF;CACnF,yFAAyF;;CAEzF,4EAA4E;CAC5E,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;;CAEpB,iEAAiE;CACjE,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;;CAElB;kFACiF;CACjF,iBAAiB;;CAEjB,4EAA4E;CAC5E,+CAA+C;CAC/C,+CAA+C;CAC/C,mFAAmF;CACnF;;oCAEmC;;CAEnC,4EAA4E;CAC5E,kBAAkB;CAClB,qBAAqB;CACrB,+CAA+C;;CAE/C,4EAA4E;CAC5E,mBAAmB;CACnB,oBAAoB;CACpB,gBAAgB;;CAEhB,4BAA4B;CAC5B,mCAAmC;CACnC,qBAAqB;;CAErB;;;;;;;;;;GAUE;CACF,2BAA2B;CAC3B,kBAAkB;CAClB,WAAW;CACX,YAAY;;CAEZ;;;;;;;;;;;;;GAaE;CACF,cAAc;AACf;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA,8EAA8E;;AAE9E;;;;;;EAME;AACF;CACC;;;;EAIC;CACD,mCAAmC;CACnC,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA,gGAAgG;AAChG;CACC,6BAA6B;CAC7B,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC;;;kDAGiD;AAClD;;AAEA;CACC,yEAAyE;CACzE,+BAA+B;AAChC;;AAEA;CACC,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;;;;;;;EAOE;AACF;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;CAC/B;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA,gFAAgF;AAChF;CACC,+BAA+B;CAC/B,gCAAgC;CAChC,0CAA0C;CAC1C,oEAAoE;AACrE;;AAEA;2EAC2E;AAC3E;CACC,gCAAgC;CAChC,uCAAuC;CACvC,oEAAoE;AACrE;;AAEA;;;;;;;;;;;;EAYE;;AAEF;CACC,mCAAmC;CACnC,gBAAgB;CAChB,gDAAgD;CAChD,0CAA0C;CAC1C,yBAAyB;CACzB,yDAAyD;AAC1D;;AAEA;;;;;EAKE;AACF;CACC,kCAAkC;CAClC,0CAA0C;CAC1C,yDAAyD;AAC1D;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,0DAA0D;CAC1D,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;CAC5B,mCAAmC;AACpC;;AAEA;CACC,mCAAmC;CACnC,gBAAgB;CAChB,wBAAwB;CACxB,gBAAgB;CAChB,6CAA6C;AAC9C;;AAEA;CACC,4BAA4B;CAC5B,gBAAgB;CAChB,wBAAwB;CACxB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA,8EAA8E;;AAE9E;;;;;EAKE;AACF;CACC,aAAa;CACb,sBAAsB;CACtB,gCAAgC;CAChC,0CAA0C;CAC1C,gBAAgB;CAChB,qBAAqB;AACtB;AACA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,UAAU;CACV,iBAAiB;CACjB,SAAS;CACT,uBAAuB;CACvB,2BAA2B;CAC3B,4BAA4B;CAC5B,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,iDAAiD;AAClD;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;CACZ,WAAW;CACX,0BAA0B;CAC1B,4BAA4B;CAC5B,UAAU;CACV,sBAAsB;CACtB;;2CAE0C;AAC3C;;AAEA;CACC,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,mCAAmC;CACnC,oBAAoB;CACpB,kCAAkC;AACnC;;AAEA;2EAC2E;AAC3E;CACC,eAAe;CACf,cAAc;CACd,oBAAoB;CACpB,kCAAkC;CAClC,2BAA2B;CAC3B,6BAA6B;CAC7B,gBAAgB;CAChB,kCAAkC;CAClC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,uBAAuB;AACxB;;AAEA,mGAAmG;AACnG;CACC,sEAAsE;CACtE,2BAA2B;AAC5B;;AAEA;;;;;;;;;;EAUE;AACF;CACC,aAAa;CACb,sBAAsB;CACtB,6BAA6B;CAC7B,0CAA0C;CAC1C,kCAAkC;CAClC,gBAAgB;CAChB,qBAAqB;AACtB;AACA;CACC,aAAa;AACd;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,UAAU;CACV,iBAAiB;CACjB,SAAS;CACT,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,4BAA4B;CAC5B,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf;;kDAEiD;AAClD;;AAEA;CACC,qBAAqB;CACrB,+DAA+D;AAChE;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,6BAA6B;CAC7B,6CAA6C;AAC9C;;AAEA;CACC,mCAAmC;CACnC,oBAAoB;AACrB;;AAEA,8EAA8E;;AAE9E;;;;;;EAME;AACF;CACC,WAAW;CACX,yBAAyB;CACzB,iBAAiB;CACjB,4BAA4B;CAC5B;;;;;;;;;GASE;CACF,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,MAAM;CACN,UAAU;CACV,YAAY;CACZ,4BAA4B;CAC5B,0CAA0C;CAC1C,yFAAyF;CACzF,8BAA8B;CAC9B,2BAA2B;CAC3B,6BAA6B;CAC7B,gBAAgB;CAChB,wCAAwC;CACxC,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;AACvC;AACA;CACC,oCAAoC;AACrC;;AAEA;CACC,uBAAuB;CACvB,8BAA8B;CAC9B,gFAAgF;CAChF,sBAAsB;AACvB;;AAEA;CACC,sCAAsC;AACvC;AACA;CACC,oCAAoC;AACrC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,4DAA4D;AAC7D;;AAEA;CACC,kCAAkC;AACnC;;AAEA;;qEAEqE;AACrE;CACC,UAAU;CACV,mDAAmD;AACpD;AACA;;CAEC,UAAU;AACX;AACA;CACC;EACC,UAAU;CACX;AACD;;AAEA;gEACgE;AAChE;CACC,kCAAkC;CAClC,qFAAqF;AACtF;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,uBAAuB;CACvB,gFAAgF;AACjF;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;CACjB,kCAAkC;AACnC;;AAEA;;;;;;;;;;;EAWE;AACF;CACC,iBAAiB;AAClB;;AAEA;6DAC6D;AAC7D;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,WAAW;CACX;;+CAE8C;CAC9C,YAAY;CACZ,gBAAgB;CAChB,SAAS;CACT,uBAAuB;CACvB,UAAU;CACV,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,uBAAuB;CACvB,eAAe;CACf,iDAAiD;AAClD;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mCAAmC;CACnC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA,8EAA8E;;AAE9E;;;;EAIE;AACF;CACC,aAAa;CACb,sBAAsB;CACtB,sBAAsB;CACtB,2CAA2C;CAC3C,gFAAgF;AACjF;;AAEA;CACC,gBAAgB;AACjB;;AAEA,8EAA8E;;AAE9E;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,YAAY;CACZ,mCAAmC;CACnC,oBAAoB;CACpB,kCAAkC;AACnC;;AAEA,8EAA8E;;AAE9E;CACC;;;uCAGsC;AACvC;;AAEA;CACC,mCAAmC;CACnC,mBAAmB;AACpB;;AAEA,8EAA8E;;AAE9E;CACC;;EAEC,UAAU;CACX;CACA;EACC,aAAa;CACd;AACD;;AAEA;CACC,kCAAkC;CAClC,8EAA8E;CAC9E,gDAAgD;AACjD;;AAEA,8EAA8E;;AAE9E;CACC;EACC,UAAU;EACV,0BAA0B;CAC3B;CACA;EACC,UAAU;EACV,wBAAwB;CACzB;AACD;;AAEA;;;;EAIE;AACF;CACC,6DAA6D;AAC9D;;AAEA,8EAA8E;;AAE9E;CACC;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;;;;EAIC,wBAAwB;CACzB;AACD","sourcesContent":["/**\n * Admin panel design tokens — scoped to `.oa-route`.\n *\n * Same discipline as the Weave (pages/multi-agent/styles/multi-agent-tokens.css) and Testing\n * (pages/testing/styles/testing-tokens.css) token layers, and deliberately NOT a copy of either:\n * the admin panel is a records surface (tables, forms, roster cards), not a conversation or a live\n * stage, so it needs table/row/toolbar primitives those two do not have. Every value derives from\n * the SAME global shell variables (--background / --card / --border / --primary / --success / …),\n * so the three modules stay one visual system without duplicating colour values.\n *\n * Rules kept intentionally tight:\n *   - 5 type sizes (micro / meta / body / title / hero) — nothing else in the module\n *   - 1 accent (global --primary) + 3 state colours (ok / warn / err), used ONLY for state\n *   - 2 surface tiers (page, raised) — no card inside a card inside a card\n *   - 1 ease, 2 durations\n *   - responsive is driven by CONTAINER queries, not viewport breakpoints: the panel lives inside a\n *     collapsible sidebar shell, so the space it actually has is not the width of the window\n */\n\n.oa-route {\n\t/* ── Type ─────────────────────────────────────────────────────────────── */\n\t--oa-fs-micro: 11px;\n\t--oa-fs-meta: 12px;\n\t--oa-fs-body: 13px;\n\t--oa-fs-title: 15px;\n\t--oa-fs-hero: 19px;\n\n\t--oa-leading-tight: 1.35;\n\t--oa-leading-body: 1.55;\n\t--oa-tracking-micro: 0.06em;\n\n\t/* ── Colour ───────────────────────────────────────────────────────────── */\n\t--oa-bg: hsl(var(--background));\n\t--oa-surface: hsl(var(--card));\n\t--oa-surface-soft: hsl(var(--muted) / 0.4);\n\t--oa-border: hsl(var(--border));\n\t/* One hairline weight for every divider in the module. The old panel mixed\n\t   `border-border`, `border-border/60` and `border-border/40` on adjacent\n\t   elements, which reads as sloppy alignment rather than as hierarchy. */\n\t--oa-divider: color-mix(in oklab, hsl(var(--border)) 58%, transparent);\n\t--oa-text: hsl(var(--foreground));\n\t--oa-text-muted: hsl(var(--muted-foreground));\n\t--oa-accent: hsl(var(--primary));\n\t--oa-accent-soft: hsl(var(--primary) / 0.1);\n\n\t/* State colours use the text-safe `-strong` variants (see globals.css): the base\n\t   --success/--warning are tuned as FILLS and measure ~2:1 as text on their own tint. */\n\t--oa-state-ok: hsl(var(--success-strong));\n\t--oa-state-warn: hsl(var(--warning-strong));\n\t--oa-state-err: hsl(var(--destructive-strong));\n\n\t/* Panel chrome — same recipe as Weave/Testing so the modules read as siblings. */\n\t--oa-app-bg: color-mix(in oklab, hsl(var(--background)) 93%, hsl(var(--foreground)) 7%);\n\t--oa-panel-bg: color-mix(in oklab, hsl(var(--card)) 94%, hsl(var(--background)) 6%);\n\t--oa-panel-bg-soft: color-mix(in oklab, hsl(var(--card)) 86%, hsl(var(--background)) 14%);\n\n\t/* ── Geometry ─────────────────────────────────────────────────────────── */\n\t--oa-radius-sm: 6px;\n\t--oa-radius-md: 10px;\n\t--oa-radius-lg: 14px;\n\n\t/* One rhythm. Every gap/padding in the module is one of these. */\n\t--oa-space-1: 4px;\n\t--oa-space-2: 8px;\n\t--oa-space-3: 12px;\n\t--oa-space-4: 16px;\n\t--oa-space-5: 24px;\n\n\t/* Horizontal gutter shared by the header, the toolbar, every table cell and every\n\t   row — so the page has exactly one left edge and one right edge at any width. */\n\t--oa-gutter: 16px;\n\n\t/* ── Depth ────────────────────────────────────────────────────────────── */\n\t--oa-shadow-soft: hsl(var(--foreground) / 0.06);\n\t--oa-shadow-hard: hsl(var(--foreground) / 0.12);\n\t--oa-shadow-sm: 0 1px 2px var(--oa-shadow-soft), 0 0 0 1px hsl(var(--border) / 0.7);\n\t--oa-shadow-md:\n\t\t0 4px 6px -1px var(--oa-shadow-soft), 0 2px 4px -2px var(--oa-shadow-soft),\n\t\t0 0 0 1px hsl(var(--border) / 0.8);\n\n\t/* ── Motion ───────────────────────────────────────────────────────────── */\n\t--oa-motion: 140ms;\n\t--oa-motion-lg: 220ms;\n\t--oa-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n\n\t/* ── Layout ───────────────────────────────────────────────────────────── */\n\t--oa-header-h: 52px;\n\t--oa-toolbar-h: 44px;\n\t--oa-row-h: 44px;\n\n\tfont-size: var(--oa-fs-body);\n\tline-height: var(--oa-leading-body);\n\tcolor: var(--oa-text);\n\n\t/*\n\t * The panel is measured against ITSELF, not the viewport. `@container` queries below key off\n\t * this, which is the only correct answer when the same component renders beside an expanded\n\t * sidebar, beside a collapsed one, and inside a dialog.\n\t *\n\t * `width: 100%` is load-bearing, not decoration: `container-type: inline-size` implies\n\t * `contain: inline-size`, which stops the contents from contributing to the element's own\n\t * width. Inside any parent that sizes children by content — a flex row, an inline-block, a\n\t * grid track set to `auto` — that collapses the whole module to its minimum width. Stating the\n\t * width explicitly makes the module immune to what its host happens to be.\n\t */\n\tcontainer-type: inline-size;\n\tcontainer-name: oa;\n\twidth: 100%;\n\tmin-width: 0;\n\n\t/*\n\t * Contain the module's height, so the panel produces ONE scrollbar instead of two.\n\t *\n\t * Every panel here is `h-full min-h-0 flex-col` with a `flex-1 overflow-y-auto` body, which is\n\t * meant to keep all scrolling inside that body. It did not: the body's content height also reached\n\t * `.studio-content` (a fixed-height block with visible overflow) and from there `.studio-main`,\n\t * whose `overflow-y: auto` then produced a SECOND scrollbar beside the panel's own. Measured on the\n\t * Overview tab: `.studio-main` 2462/900 and scrollable, with the inner body already at 3003/655.\n\t *\n\t * `clip` rather than `hidden`, matching `.studio-shell`'s existing `overflow-y: clip`: it contains\n\t * the overflow without creating a scroll container, so nothing can be programmatically scrolled\n\t * here by accident. Verified that the inner body still scrolls on every tab and that sticky table\n\t * headers still resolve against it, since their scrollport is inside this element.\n\t */\n\toverflow: clip;\n}\n\n@container oa (min-width: 720px) {\n\t.oa-route {\n\t\t--oa-gutter: 20px;\n\t}\n}\n\n/* ── Surfaces ───────────────────────────────────────────────────────────── */\n\n/*\n * The whole panel is ONE surface. The previous version nested a `studio-card` inside a\n * `studio-card` inside a `Card` (three borders and three backgrounds between the page and a\n * number), which is what made it read as a template rather than a product. Sections are separated\n * by hairlines and whitespace; a border is spent only where something is genuinely a raised object\n * (a role card the user can act on).\n */\n.oa-route .oa-panel {\n\tbackground: linear-gradient(\n\t\t180deg,\n\t\tcolor-mix(in oklab, var(--oa-panel-bg) 98%, hsl(var(--foreground)) 2%),\n\t\tvar(--oa-panel-bg)\n\t);\n\tborder: 1px solid var(--oa-divider);\n\tborder-radius: var(--oa-radius-md);\n\toverflow: hidden;\n}\n\n/* A raised object inside the panel — a role card, a stat tile. Exactly one border level deep. */\n.oa-route .oa-raised {\n\tbackground: var(--oa-surface);\n\tborder: 1px solid var(--oa-divider);\n\tborder-radius: var(--oa-radius-md);\n}\n\n.oa-route .oa-raised-interactive {\n\ttransition:\n\t\tborder-color var(--oa-motion) var(--oa-ease),\n\t\tbox-shadow var(--oa-motion) var(--oa-ease),\n\t\tbackground-color var(--oa-motion) var(--oa-ease);\n}\n\n.oa-route .oa-raised-interactive:hover {\n\tborder-color: color-mix(in oklab, var(--oa-accent) 34%, var(--oa-border));\n\tbox-shadow: var(--oa-shadow-sm);\n}\n\n.oa-route .oa-header {\n\tmin-height: var(--oa-header-h);\n\tpadding-inline: var(--oa-gutter);\n}\n\n/*\n * The header switches between two deliberate layouts rather than being allowed to wrap.\n *\n * Wrapping looked fine until it happened: the spend figure is right-aligned so its digits line up\n * with the page's right edge, and once the header wrapped, \"right\" was the right edge of the\n * figure's own little box in the middle of a new line, which reads as an alignment mistake. Below\n * the threshold the stat is simply a second line under the title, left-aligned like everything else.\n */\n.oa-route .oa-header {\n\tflex-direction: column;\n\talign-items: flex-start;\n}\n\n.oa-route .oa-header-stat {\n\ttext-align: left;\n}\n\n@container oa (min-width: 760px) {\n\t.oa-route .oa-header {\n\t\tflex-direction: row;\n\t\talign-items: flex-start;\n\t\tjustify-content: space-between;\n\t}\n\n\t.oa-route .oa-header-stat {\n\t\ttext-align: right;\n\t}\n}\n\n/* Toolbar strip above a table: search, filters, the section's primary action. */\n.oa-route .oa-toolbar {\n\tmin-height: var(--oa-toolbar-h);\n\tpadding-inline: var(--oa-gutter);\n\tborder-bottom: 1px solid var(--oa-divider);\n\tbackground: color-mix(in oklab, var(--oa-panel-bg) 86%, transparent);\n}\n\n/* Footer strip under a table: result counts, pagination. Mirrors the toolbar so a table is\n   visually bracketed by two matching rails instead of ending in mid-air. */\n.oa-route .oa-footer-rail {\n\tpadding-inline: var(--oa-gutter);\n\tborder-top: 1px solid var(--oa-divider);\n\tbackground: color-mix(in oklab, var(--oa-panel-bg) 86%, transparent);\n}\n\n/* ── Type utilities ───────────────────────────────────────────────────────\n *\n * Deliberately UNSCOPED, unlike everything else in this file.\n *\n * Radix renders dialogs in a portal on `<body>`, outside `.oa-route` — so scoped as\n * `.oa-route .oa-meta` these silently did nothing inside every dialog in the module, and a label\n * meant to be 11px uppercase muted rendered as plain body text. The bug is invisible in review\n * because the markup looks right.\n *\n * `.oa-route` still supplies the CUSTOM PROPERTIES these read, and every var has a fallback for the\n * portal case. The `oa-` prefix is unique to this module, so unscoping cannot collide. The\n * `[data-tone]` variants stay one specificity step above the base, which is what they need.\n */\n\n.oa-micro {\n\tfont-size: var(--oa-fs-micro, 11px);\n\tfont-weight: 600;\n\tletter-spacing: var(--oa-tracking-micro, 0.06em);\n\tline-height: var(--oa-leading-tight, 1.35);\n\ttext-transform: uppercase;\n\tcolor: var(--oa-text-muted, hsl(var(--muted-foreground)));\n}\n\n/*\n * `.oa-meta` is (0,2,0) and therefore beats a Tailwind colour utility like `text-foreground`\n * (0,1,0) — so `className=\"oa-meta text-foreground\"` silently rendered muted. Rather than leave\n * that trap for the next person, the two colours meta text is allowed to take are part of the\n * class, selected with `data-tone`. Anything not expressible here should not be `.oa-meta`.\n */\n.oa-meta {\n\tfont-size: var(--oa-fs-meta, 12px);\n\tline-height: var(--oa-leading-tight, 1.35);\n\tcolor: var(--oa-text-muted, hsl(var(--muted-foreground)));\n}\n\n.oa-meta[data-tone=\"strong\"] {\n\tcolor: var(--oa-text, hsl(var(--foreground)));\n}\n\n.oa-meta[data-tone=\"err\"] {\n\tcolor: var(--oa-state-err, hsl(var(--destructive-strong)));\n\tfont-weight: 500;\n}\n\n.oa-body {\n\tfont-size: var(--oa-fs-body);\n\tline-height: var(--oa-leading-body);\n}\n\n.oa-title {\n\tfont-size: var(--oa-fs-title, 15px);\n\tfont-weight: 600;\n\tletter-spacing: -0.011em;\n\tline-height: 1.3;\n\tcolor: var(--oa-text, hsl(var(--foreground)));\n}\n\n.oa-hero {\n\tfont-size: var(--oa-fs-hero);\n\tfont-weight: 600;\n\tletter-spacing: -0.014em;\n\tline-height: 1.25;\n\tcolor: var(--oa-text);\n}\n\n/* ── Tabs ───────────────────────────────────────────────────────────────── */\n\n/*\n * Underline tabs on a Radix Tabs root, so the roving-tabindex/arrow-key behaviour and the\n * tab/tabpanel wiring come from the primitive rather than from hand-rolled buttons. The underline\n * is a pseudo-element on the ACTIVE trigger — the previous implementation animated a fixed-width\n * (`w-16`) bar to a computed percentage, so it only lined up with a tab by coincidence.\n */\n.oa-route .oa-tablist {\n\tdisplay: flex;\n\tgap: var(--oa-space-1);\n\tpadding-inline: var(--oa-gutter);\n\tborder-bottom: 1px solid var(--oa-divider);\n\toverflow-x: auto;\n\tscrollbar-width: none;\n}\n.oa-route .oa-tablist::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.oa-route .oa-tab {\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tflex: none;\n\tpadding: 9px 10px;\n\tborder: 0;\n\tbackground: transparent;\n\tcolor: var(--oa-text-muted);\n\tfont-size: var(--oa-fs-body);\n\tfont-weight: 500;\n\twhite-space: nowrap;\n\tcursor: pointer;\n\ttransition: color var(--oa-motion) var(--oa-ease);\n}\n\n.oa-route .oa-tab:hover {\n\tcolor: var(--oa-text);\n}\n\n.oa-route .oa-tab[data-state=\"active\"] {\n\tcolor: var(--oa-text);\n\tfont-weight: 600;\n}\n\n.oa-route .oa-tab::after {\n\tcontent: \"\";\n\tposition: absolute;\n\tinset-inline: 6px;\n\tbottom: -1px;\n\theight: 2px;\n\tborder-radius: 2px 2px 0 0;\n\tbackground: var(--oa-accent);\n\topacity: 0;\n\ttransform: scaleX(0.6);\n\ttransition:\n\t\topacity var(--oa-motion) var(--oa-ease),\n\t\ttransform var(--oa-motion) var(--oa-ease);\n}\n\n.oa-route .oa-tab[data-state=\"active\"]::after {\n\topacity: 1;\n\ttransform: scaleX(1);\n}\n\n.oa-route .oa-tab:focus-visible {\n\toutline: 2px solid var(--oa-accent);\n\toutline-offset: -2px;\n\tborder-radius: var(--oa-radius-sm);\n}\n\n/* Count pill on a tab — the number lives on the thing it counts, instead of in a separate\n   always-on stat strip that repeated the same four numbers on every tab. */\n.oa-route .oa-tab-count {\n\tmin-width: 18px;\n\tpadding: 0 5px;\n\tborder-radius: 999px;\n\tbackground: var(--oa-surface-soft);\n\tcolor: var(--oa-text-muted);\n\tfont-size: var(--oa-fs-micro);\n\tfont-weight: 600;\n\tfont-variant-numeric: tabular-nums;\n\tline-height: 16px;\n\ttext-align: center;\n}\n\n.oa-route .oa-tab[data-state=\"active\"] .oa-tab-count {\n\tbackground: var(--oa-accent-soft);\n\tcolor: var(--oa-accent);\n}\n\n/* An unresolved count that needs attention (pending invitations) reads as state, not decoration. */\n.oa-route .oa-tab-count[data-tone=\"warn\"] {\n\tbackground: color-mix(in oklab, var(--oa-state-warn) 14%, transparent);\n\tcolor: var(--oa-state-warn);\n}\n\n/*\n * ── Sub-tabs ────────────────────────────────────────────────────────────────\n *\n * The second navigation row, inside People. Deliberately QUIETER than `.oa-tab`: two tab bars of\n * equal weight stacked on top of each other read as one confusing eight-item bar, and the reader\n * cannot tell which level they are choosing at. So this row is smaller, sits on the soft surface\n * rather than on the page ground, and marks its selection with a filled pill instead of a second\n * accent underline competing with the one directly above it.\n *\n * It reuses `.oa-tab-count`, so a count means the same thing on both levels.\n */\n.oa-route .oa-subtablist {\n\tdisplay: flex;\n\tgap: var(--oa-space-1);\n\tpadding: 6px var(--oa-gutter);\n\tborder-bottom: 1px solid var(--oa-divider);\n\tbackground: var(--oa-surface-soft);\n\toverflow-x: auto;\n\tscrollbar-width: none;\n}\n.oa-route .oa-subtablist::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.oa-route .oa-subtab {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tflex: none;\n\tpadding: 5px 10px;\n\tborder: 0;\n\tborder-radius: var(--oa-radius-sm);\n\tbackground: transparent;\n\tcolor: var(--oa-text-muted);\n\tfont-size: var(--oa-fs-meta);\n\tfont-weight: 500;\n\twhite-space: nowrap;\n\tcursor: pointer;\n\ttransition:\n\t\tcolor var(--oa-motion) var(--oa-ease),\n\t\tbackground-color var(--oa-motion) var(--oa-ease);\n}\n\n.oa-route .oa-subtab:hover {\n\tcolor: var(--oa-text);\n\tbackground: color-mix(in oklab, var(--oa-text) 6%, transparent);\n}\n\n.oa-route .oa-subtab[data-state=\"active\"] {\n\tcolor: var(--oa-text);\n\tfont-weight: 600;\n\tbackground: var(--oa-surface);\n\tbox-shadow: inset 0 0 0 1px var(--oa-divider);\n}\n\n.oa-route .oa-subtab:focus-visible {\n\toutline: 2px solid var(--oa-accent);\n\toutline-offset: -2px;\n}\n\n/* ── Table ──────────────────────────────────────────────────────────────── */\n\n/*\n * The module's single table idiom. Members, invitations, per-member usage and per-service usage all\n * use it, so a column header, a row height and a numeric cell mean the same thing everywhere.\n * The @ncoder/ui Table primitive's defaults (h-12 header, p-4 cells) are tuned for marketing-density\n * tables; an admin roster needs to show 12 rows without scrolling, not 4. Overridden here rather\n * than in the primitive so no other module's tables move.\n */\n.oa-route .oa-table {\n\twidth: 100%;\n\tborder-collapse: separate;\n\tborder-spacing: 0;\n\tfont-size: var(--oa-fs-body);\n\t/*\n\t * `fixed`, so a column's width is the width it was given rather than the width of its widest\n\t * unbreakable value. Under the default `auto` algorithm a single long address —\n\t * \"priya.raghunathan@a-very-long-customer-domain-name.example.com\" — widened its column past the\n\t * panel, pushed every other column off the right edge and made `truncate` a no-op, because a\n\t * column that has already grown to fit its content has nothing to truncate.\n\t *\n\t * Every table in the module gives an explicit width to all of its columns except the one that\n\t * should absorb the remainder, which is exactly the contract `fixed` needs.\n\t */\n\ttable-layout: fixed;\n}\n\n.oa-route .oa-table thead th {\n\tposition: sticky;\n\ttop: 0;\n\tz-index: 1;\n\theight: 34px;\n\tpadding: 0 var(--oa-space-3);\n\tborder-bottom: 1px solid var(--oa-divider);\n\t/* Opaque: the body scrolls UNDER the header, so a translucent header would smear rows. */\n\tbackground: var(--oa-panel-bg);\n\tcolor: var(--oa-text-muted);\n\tfont-size: var(--oa-fs-micro);\n\tfont-weight: 600;\n\tletter-spacing: var(--oa-tracking-micro);\n\ttext-transform: uppercase;\n\ttext-align: left;\n\twhite-space: nowrap;\n}\n\n.oa-route .oa-table thead th:first-child {\n\tpadding-inline-start: var(--oa-gutter);\n}\n.oa-route .oa-table thead th:last-child {\n\tpadding-inline-end: var(--oa-gutter);\n}\n\n.oa-route .oa-table tbody td {\n\theight: var(--oa-row-h);\n\tpadding: 6px var(--oa-space-3);\n\tborder-bottom: 1px solid color-mix(in oklab, var(--oa-divider) 60%, transparent);\n\tvertical-align: middle;\n}\n\n.oa-route .oa-table tbody td:first-child {\n\tpadding-inline-start: var(--oa-gutter);\n}\n.oa-route .oa-table tbody td:last-child {\n\tpadding-inline-end: var(--oa-gutter);\n}\n\n.oa-route .oa-table tbody tr:last-child td {\n\tborder-bottom: 0;\n}\n\n.oa-route .oa-table tbody tr {\n\ttransition: background-color var(--oa-motion) var(--oa-ease);\n}\n\n.oa-route .oa-table tbody tr:hover {\n\tbackground: var(--oa-surface-soft);\n}\n\n/* Row-level actions stay hidden until the row is hovered or something inside it has focus, so a\n   long roster reads as data rather than as a wall of icon buttons — but they are never hidden from\n   the keyboard or from a touch device, where `:hover` never fires. */\n.oa-route .oa-row-actions {\n\topacity: 0;\n\ttransition: opacity var(--oa-motion) var(--oa-ease);\n}\n.oa-route tr:hover .oa-row-actions,\n.oa-route tr:focus-within .oa-row-actions {\n\topacity: 1;\n}\n@media (hover: none) {\n\t.oa-route .oa-row-actions {\n\t\topacity: 1;\n\t}\n}\n\n/* A nested detail table (the per-service breakdown inside an expanded member row) must not carry\n   the same weight as its parent, or the nesting is invisible. */\n.oa-route .oa-subtable-shell {\n\tbackground: var(--oa-surface-soft);\n\tborder-inline-start: 2px solid color-mix(in oklab, var(--oa-accent) 45%, transparent);\n}\n\n.oa-route .oa-subtable thead th {\n\tposition: static;\n\theight: 28px;\n\tbackground: transparent;\n\tborder-bottom: 1px solid color-mix(in oklab, var(--oa-divider) 60%, transparent);\n}\n\n.oa-route .oa-subtable tbody td {\n\theight: 32px;\n\tborder-bottom: 0;\n}\n\n.oa-route .oa-subtable tbody tr:hover {\n\tbackground: transparent;\n}\n\n.oa-route .oa-num {\n\ttext-align: right;\n\tfont-variant-numeric: tabular-nums;\n}\n\n/*\n * A numeric column's HEADER, right-aligned over the figures it names.\n *\n * This rule exists because `text-align: left` on `.oa-route .oa-table thead th` (0,2,2) silently beat\n * the Tailwind `.text-right` utility (0,1,0) that `PlainHeader align=\"right\"` emitted — so every\n * numeric header in the module sat left-aligned above right-aligned values, and had done since the\n * table chrome was written. Measured, not guessed: `getComputedStyle(th).textAlign` returned `left`\n * on every such header across all four tabs.\n *\n * Expressed as `th.oa-num` rather than by weakening the base rule, so headers and cells now share one\n * word for \"this column is numeric\" — the same vocabulary the cells already used.\n */\n.oa-route .oa-table thead th.oa-num {\n\ttext-align: right;\n}\n\n/* Sortable column header. The whole cell is the hit target, and the arrow only appears for the\n   column actually in effect so the header row stays quiet. */\n.oa-route .oa-th-sort {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 4px;\n\twidth: 100%;\n\t/* Fills the header cell rather than wrapping only the text: a 17px-tall click target is under\n\t   the WCAG 2.2 minimum, and a header whose hit area is smaller than the header is a small,\n\t   constant irritation when sorting a table. */\n\theight: 100%;\n\tmin-height: 24px;\n\tborder: 0;\n\tbackground: transparent;\n\tpadding: 0;\n\tcolor: inherit;\n\tfont: inherit;\n\tletter-spacing: inherit;\n\ttext-transform: inherit;\n\tcursor: pointer;\n\ttransition: color var(--oa-motion) var(--oa-ease);\n}\n\n.oa-route .oa-th-sort:hover {\n\tcolor: var(--oa-text);\n}\n\n.oa-route .oa-th-sort:focus-visible {\n\toutline: 2px solid var(--oa-accent);\n\toutline-offset: 2px;\n\tborder-radius: 3px;\n}\n\n.oa-route th[aria-sort]:not([aria-sort=\"none\"]) .oa-th-sort {\n\tcolor: var(--oa-text);\n}\n\n/* ── Card-view fallback for a narrow container ──────────────────────────── */\n\n/*\n * A 6-column roster cannot be squeezed into a 380px panel — squeezing it is exactly how admin\n * tables end up with 3-character-wide columns. Below the container breakpoint the same rows render\n * as stacked cards (see `useOaNarrow`), and this is the shell for those.\n */\n.oa-route .oa-card-row {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--oa-space-2);\n\tpadding: var(--oa-space-3) var(--oa-gutter);\n\tborder-bottom: 1px solid color-mix(in oklab, var(--oa-divider) 60%, transparent);\n}\n\n.oa-route .oa-card-row:last-child {\n\tborder-bottom: 0;\n}\n\n/* ── Segmented control ──────────────────────────────────────────────────── */\n\n.oa-route .oa-segmented {\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 2px;\n\tpadding: 2px;\n\tborder: 1px solid var(--oa-divider);\n\tborder-radius: 999px;\n\tbackground: var(--oa-surface-soft);\n}\n\n/* ── Interactive ────────────────────────────────────────────────────────── */\n\n.oa-route .oa-interactive {\n\ttransition:\n\t\tbackground-color var(--oa-motion) var(--oa-ease),\n\t\tborder-color var(--oa-motion) var(--oa-ease),\n\t\tcolor var(--oa-motion) var(--oa-ease);\n}\n\n.oa-route :where(button, a, input, select, textarea, [tabindex]):focus-visible {\n\toutline: 2px solid var(--oa-accent);\n\toutline-offset: 2px;\n}\n\n/* ── Skeleton ───────────────────────────────────────────────────────────── */\n\n@keyframes oa-pulse {\n\t0%,\n\t100% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0.45;\n\t}\n}\n\n.oa-route .oa-skeleton {\n\tborder-radius: var(--oa-radius-sm);\n\tbackground: color-mix(in oklab, hsl(var(--muted-foreground)) 12%, transparent);\n\tanimation: oa-pulse 1.6s var(--oa-ease) infinite;\n}\n\n/* ── Entrance ───────────────────────────────────────────────────────────── */\n\n@keyframes oa-fade-in {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translateY(3px);\n\t}\n\t100% {\n\t\topacity: 1;\n\t\ttransform: translateY(0);\n\t}\n}\n\n/*\n * ONE entrance animation on the tab panel as a whole. The previous version ran a `useTrail` spring\n * per row plus a cross-fade between two absolutely-stacked panels — 200 members meant 200 springs\n * driving 200 committed frames, and the stagger delayed the data an admin came to read.\n */\n.oa-route .oa-fade-in {\n\tanimation: oa-fade-in var(--oa-motion-lg) var(--oa-ease) both;\n}\n\n/* ── Reduced motion ─────────────────────────────────────────────────────── */\n\n@media (prefers-reduced-motion: reduce) {\n\t.oa-route .oa-fade-in {\n\t\tanimation: none;\n\t}\n\t.oa-route .oa-skeleton {\n\t\tanimation: none;\n\t}\n\t.oa-route .oa-tab::after,\n\t.oa-route .oa-interactive,\n\t.oa-route .oa-raised-interactive,\n\t.oa-route .oa-row-actions {\n\t\ttransition-duration: 1ms;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
